<template>
  <div>
    <ul class="pdflist" v-show="state1">
      <li v-for="(item,index) in listdata" :key="index" @click="intoIframe(item.pdf_url)">{{item.title}}</li>
    </ul>
    <iframe :src="iframeUrl" width="100%" height="694px" v-if="state2"></iframe>
  </div>
</template>
<script>
import {ipconfig} from '@/assets/js/ipconfig.js'
import Axios from "axios";
export default {
  name: "pipedepartment",
  data() {
    return {
      state1:true,
      state2:false,
      iframeUrl:'',
      listdata: ""
    };
  },
  mounted() {
    this.getDatas();
  },
  methods: {
    getDatas() {
      Axios.get(
        `http://${ipconfig}/app/isweb/license/getLicenseInfo?innerMS&con_license_type=0301`
      ).then(res => {
        console.log(res)
        if(res.data.isSuccess){
          this.listdata = res.data.data.licenseInfolist
        }
        
      });
    },
    intoIframe(url){
      this.state1 = false;
      this.state2 = true;
      this.iframeUrl = url
    }
  }
};
</script>
<style scoped>
.pdflist li{
  font-size: 14px;
  height: 40px;
  padding-left: 10px;
  line-height: 40px;
  border-bottom:1px dashed #ccc; 
}
</style>


// WEBPACK FOOTER //
// src/pages/hyjdmsg/pipedepartment.vue